import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from './protectedRoute';
import Topbar from './navigation/topbar';
import BasicLogin from './login/basicLogin';
import Home from './home/home';
import IAM from './IAM/IAM';
import Users from './org_admin/Users/Users'
import Onboard from './super_admin/onboard/Onboard';
import ForgotPassword from './login/ForgotPassword';
import ResetPassword from './login/ResetPassword';
import DetailsDashboard from './super_admin/dashboard/DetailsDashboard';

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <BasicLogin />
        }
      />

      <Route
        path="/forgot-password"
        element={
          <ForgotPassword />
        }
      />

      <Route
        path="/details-dashboard"
        element={
          <DetailsDashboard />
        }
      />
      <Route
        path="/reset-password"
        element={
          <ResetPassword />
        }
      />
      <Route
        path="/app/home"
        element={
          <ProtectedRoute>
            <Topbar title="Dashboard">
              <Home />
            </Topbar>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/IAM"
        element={
          <ProtectedRoute>
            <Topbar title="Identity Access Management">
              <IAM />
            </Topbar>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/users"
        element={
          <ProtectedRoute>
            <Topbar>
              <Users />
            </Topbar>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/onboard"
        element={
          <ProtectedRoute>
            <Topbar title="Onboard Organization">
              <Onboard />
            </Topbar>
          </ProtectedRoute>
        }
      >
      </Route>
    </Routes>
  );
}

export default App;
